const prefix = '/standard-topics';

export const STANDARDS_TOPIC_TAG = `${prefix}`;
export const STANDARDS_TOPIC_DETAILS_TAG = `${prefix}/id`;
